import { combineReducers } from 'redux';
import {
    IntroTourFetchSuccessActionType,
    IntroTourFetchRequestActionType,
    IntroTourFetchFailureActionType,
} from './introTourAction';
import { ActionType } from 'store/ActionType';
import { TourOptions } from 'intro.js/src/packages/tour/option';

const introTour = (
    state: Nullable<TourOptions> = null,
    action: ActionType,
) => {
    if (action.type === IntroTourFetchSuccessActionType) {
        return action.payload;
    }
    return state;
};

const isLoading = (state = false, action: ActionType) => {
    switch (action.type) {
        case IntroTourFetchRequestActionType: {
            return true;
        }
        case IntroTourFetchFailureActionType:
        case IntroTourFetchSuccessActionType: {
            return false;
        }
        default: {
            return state;
        }
    }
};

export default combineReducers({
    introTour,
    isLoading,
});
